import css from './index.module.scss';
import Manual from './icons/Manual';
import Eye from './icons/Eye';
import Download from './icons/Download';
import { useGlobal } from '@/utils/useGlobal';

export default function Manuals({ manualList, theme }: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('shared.product');
    return (
        <section className={`product-support-manuals ${css['product-support-manuals']} ${theme}`}>
            <ul className="manula-list">
                {manualList?.map((manual: any, k: numner) => (
                    <li className="manual-item" key={k}>
                        <div className="manual-info">
                            <Manual />
                            <div className="manual-text">
                                <p className="manual-title">{manual?.title}</p>
                                <p className="manual-update">{manual?.updateTime}</p>
                            </div>
                        </div>
                        <a className="manual-btn" href={manual?.fileUrl} aria-label={manual?.title} target="_blank" rel="noreferrer">
                            {manual?.classify === 'ONLINE' ? <Eye /> : <Download />}
                            <span className="btn-text">{manual?.classify === 'ONLINE' ? t('online') : 'PDF'}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </section>
    );
}
